<script>
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import { FormWizard, TabContent } from "vue-form-wizard";
import validation from '../../../helpers/validation';
import axios from 'axios';
import ErrorAlert from "@/components/errorAlert";
import PhoneSelect from "../../../components/phoneSelect";
import {countryToCallPrefix} from "@/helpers/countries";
import DateInput from "@/components/dateInput";

export default {
  page: {
    title: "Initial profile setup",
    meta: [{ name: "description", content: '' }],
  },
  components: {
    DateInput,
    PhoneSelect,
    ErrorAlert,
    Layout,
    Multiselect,
    FormWizard,
    TabContent
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    'companyForms.personalInfo.fields.country.value': function(newValue, oldValue) {
      this.companyForms.personalInfo.fields.phone_number.value = countryToCallPrefix[newValue]
    },
    // eslint-disable-next-line no-unused-vars
    'individualForms.personalInfo.fields.country.value': function(newValue, oldValue) {
      this.individualForms.personalInfo.fields.phone_number.value = countryToCallPrefix[newValue]
    }
  },
  data() {
    return {
      title: "Initial profile setup",
      showModal: false,
      items: [
        {
          text: "Initial profile setup",
          active: true
        },
      ],
      categories: {
        selected: [],
        error: false,
      },
      registeredAs: 'company',
      companyForms: {
        personalInfo: {
          name: 'Company Info',
          fields: {
            company_name: {
              name: 'Full company name',
              value: '',
              required: true,
              error: false,
            },
            contact_person: {
              name: 'Contact person',
              value: '',
              required: true,
              error: false
            },
            vat_number: {
              name: 'VAT number',
              value: '',
              required: true,
              error: false
            },
            company_number: {
              name: 'Registration number',
              value: '',
              required: true,
              error: false
            },
            taxpayer: {
              name: 'VAT (PDV)',
              value: true,
              type: 'radio',
              required: true,
              error: false
            },
            name: {
              name: 'Full name',
              value: '',
              required: true,
              error: false,
            },
            date_of_birth: {
              name: 'Date of Birth',
              value: '',
              type: 'date',
              required: true,
              error: false,
            },
            gender: {
              name: 'Gender',
              value: '',
              options: ['male', 'female'],
              type: 'select',
              required: true,
              error: false,
            },
            country: {
              name: 'Country',
              value: '',
              options: ['Serbia', 'Bosnia and Herzegovina', 'Slovenia', 'Croatia', 'Montenegro', 'Macedonia'],
              type: 'select',
              required: true,
              error: false,
            },
            city: {
              name: 'City',
              value: '',
              required: true,
              error: false,
            },
            postal_code: {
              name: 'Postal code',
              value: '',
              required: true,
              error: false,
            },
            street_address: {
              name: 'Street address',
              value: '',
              required: true,
              error: false
            },
            phone_number: {
              name: 'Phone',
              value: '',
              type: 'phone',
              required: true,
              error: false,
            },
          }
        },
        bankingInfo: {
          name: 'Banking info',
          fields: {
            bank: {
              name: 'Bank',
              value: '',
              required: true,
              error: false,
            },
            bank_account_number: {
              name: 'Bank account number',
              value: '',
              required: true,
              error: false,
              placeholder: 'ex. 200000000012345600',
              autocomplete: 'cc-number'
            }
          },
        },
        deliveryInfo: {
          name: 'Delivery info',
          fields: {
            delivery_city: {
              name: 'City',
              value: '',
              required: true,
              error: false,
            },
            delivery_postal_code: {
              name: 'Postal code',
              value: '',
              required: true,
              error: false,
            },
            delivery_street_address: {
              name: 'Street Address',
              value: '',
              required: true,
              error: false
            },
            delivery_contact_person: {
              name: 'Contact person',
              value: '',
              required: true,
              error: false
            },
            delivery_phone_number: {
              name: 'Phone number of the contact person',
              value: '',
              required: true,
              type: 'phone',
              error: false
            }
          },
        }
      },
      individualForms: {
        personalInfo: {
          name: 'Personal Info',
          fields: {
            job_status: {
              name: 'Job status',
              value: '',
              options: ['Unemployed (nezaposlen)', 'Insured (zaposlen/penzioner)', 'With special permission (sa potvrdom)'],
              type: 'select',
              error: false,
            },
            unique_personal_identification_number: {
              name: 'Unique Personal Identification Number (JMBG)',
              value: '',
              required: true,
              error: false,
            },
            name: {
              name: 'Full name',
              value: '',
              required: true,
              error: false,
            },
            date_of_birth: {
              name: 'Date of Birth',
              value: '',
              type: 'date',
              required: true,
              error: false,
            },
            gender: {
              name: 'Gender',
              value: '',
              options: ['male', 'female'],
              type: 'select',
              error: false,
            },
            country: {
              name: 'Country',
              value: '',
              options: ['Serbia', 'Bosnia and Herzegovina', 'Slovenia', 'Croatia', 'Montenegro', 'Macedonia'],
              type: 'select',
              required: true,
              error: false,
            },
            city: {
              name: 'City',
              value: '',
              required: true,
              error: false,
            },
            postal_code: {
              name: 'Postal code',
              value: '',
              required: true,
              error: false,
            },
            street_address: {
              name: 'Street address',
              value: '',
              required: true,
              error: false
            },
            phone_number: {
              name: 'Phone',
              value: '',
              type: 'phone',
              required: true,
              error: false,
            },
          }
        },
        bankingInfo: {
          name: 'Banking info',
          fields: {
            bank: {
              name: 'Bank',
              value: '',
              required: true,
              error: false,
            },
            bank_account_number: {
              name: 'Bank account number',
              value: '',
              required: true,
              error: false,
              placeholder: 'ex. 200000000012345600',
              autocomplete: 'cc-number'
            }
          },
        },
        deliveryInfo: {
          name: 'Delivery info',
          fields: {
            delivery_city: {
              name: 'City',
              value: '',
              required: true,
              error: false,
            },
            delivery_postal_code: {
              name: 'Postal code',
              value: '',
              required: true,
              error: false,
            },
            delivery_street_address: {
              name: 'Street Address',
              value: '',
              required: true,
              error: false
            },
            delivery_contact_person: {
              name: 'Contact person',
              value: '',
              required: true,
              error: false
            },
            delivery_phone_number: {
              name: 'Phone number of the contact person',
              value: '',
              required: true,
              type: 'phone',
              error: false
            }
          },
        }
      }
    };
  },

  computed: {
    categoriesOptions () {
      return this.$store.state.user.categories;
    },
    selectedFormsName() {
      return this.registeredAs + 'Forms';
    },
    selectedForms() {
      return this[this.selectedFormsName];
    },
  },
  methods: {
    navigate () {
      this.$router.push('/');
    },
    async complete () {
      if(this.categories.selected.length < 1) {
        this.categories.error = true;
      } else {
        try{
          this.$store.commit('loader/START_LOADING');

          const requestData = {
            registered_as: this.registeredAs,
            categories: this.categories.selected,
          }

          // eslint-disable-next-line no-unused-vars
          for (let [formKey, formValue] of Object.entries(this.selectedForms)) {
            for (let [inputKey, inputValue] of Object.entries(formValue.fields)) {
              requestData[inputKey] = inputValue.value;
              if (inputKey === 'job_status') {
                // TODO: support object values in dynamic multiselect to evade this
                if (inputValue.value === 'With special permission (sa potvrdom)') {
                  requestData[inputKey] = 'with_contract';
                } else if (inputValue.value === 'Unemployed (nezaposlen)') {
                  requestData[inputKey] = 'unemployed';
                } else if (inputValue.value === 'Insured (zaposlen/penzioner)') {
                  requestData[inputKey] = 'insured';
                } else {
                  requestData[inputKey] = 'unemployed';
                }
              }
            }
          }

          const { data } = await axios.put('/profile', requestData);
          this.$store.commit('user/SET_USER', data);

          this.$router.push('/');
        } catch (err) {
          // eslint-disable-next-line no-empty
        } finally{
          this.$store.commit('loader/END_LOADING');
        }
      }
    },
    prevTab () {
      this.$refs.formWizard.prevTab();
    },
    async nextTab (tabIndex) {
      try {
        if(tabIndex === 2) {
          await this.$store.dispatch('user/getCategories');
        }
        this.$refs.formWizard.nextTab();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    },
    validatepersonalInfo () {
      return this.validate('personalInfo');
    },
    validatedeliveryInfo () {
      return this.validate('deliveryInfo');
    },
    validatebankingInfo () {
      return this.validate('bankingInfo');
    },
    generateCallback (formKey) {
      return this[`validate${formKey}`];
    },
    async validate(formName) {
      let isValid = true;
      let fields = this.selectedForms[formName].fields;
      for (let field in this.selectedForms[formName].fields) {

        // check if field is empty
        if(fields[field].value === '' || fields[field].value === null) {
          fields[field].error = true;
          isValid = false;
        }

        // check special type of fields
        if(fields[field].type && validation[fields[field].type] !== undefined) {
          if(!validation[fields[field].type](fields[field].value)) {
            fields[field].error = true;
            isValid = false;
          }
        }
      }

      // need to return a promise
      if (isValid) {
        return true;
      } else {
        throw new Error('');
      }
    }
  }
};
</script>

<template>

  <Layout>
    <ErrorAlert></ErrorAlert>

    <div class="row">
      <div class="col-12 offset-xl-2 col-xl-8 mb-5">
        <div class="card">
          <div class="card-body">
            <form-wizard color="#01baf1" ref="formWizard">
              <tab-content title="Intro">
                <h3 class="mb-4">Dobrodošli</h3>
                <div class="row">
                  <div class="col-12 font-size-14">
                    <p>
                      Dragi korisniče,<br><br>
                      Dobro došao na našu Influencertes platformu. Zamolićemo te da prilikom registracije obratiš pažnju na sledeće:
                    </p>
                    <ol>
                      <li>Registracija i povezivanje na platformu se isključivo vrše preko <b>desktop</b> računara.</li>
                      <li>Kao influenser, možeš imati svoju registrovanu firmu, u tom slučaju se registruješ kao <i><b>Company</b></i></li>
                      <li>Ukoliko nemaš registrovanu firmu, registruješ se kao <i><b>Individual</b></i>. Šta to za tebe znači:
                        <ul>
                          <li>Možeš da odabereš svoj status u zavisnosti od toga da li si zaposlen, nezaposlen ili si fizičko lice sa potvrdom (to je ono lice koje poseduje potvrdu PiO fonda da je za njega za tekuću godinu već plaćena maksimalna osnovica poreza).</li>
                          <li>Zbog toga što ćemo za tebe platiti poreze i doprinose, cene koje definišeš će se uvećati za procenat poreza i doprinosa. Ali nemoj da te ovo brine, klijenti i agencije vole da je sve zakonski pokriveno i to je bitnije od svega.</li>
                          <li>Za svaku kampanju za koju ćete angažovati neka firma ili marketinška agencija, dužni smo da sa tobom napravimo ugovor o delu. Zbog ovoga nam je potreban JMBG broj i njega ćemo iskoristiti samo za ove potrebe.</li>
                        </ul>
                      </li>
                      <li>Svi podaci koje ostaviš na platformi, nebitno da li si pravno ili fizičko lice, služiće isključivo za potrebe realizacije posla između tebe i nas.</li>
                      <li>Što se tiče permisija i bezbednosti, odobreni smo od strane Google-a za analitiku i YouTube, kao i od strane Facebook-a za Facebook i Instagram. Mi kao paltforma samo možemo da vidimo tvoje statistike, kao i statistike za objave koje si zakazali preko platforme, što nam je potrebno kasnije sa izveštaj i ništa više od toga.</li>
                    </ol>
                    <p>
                      Čim završiš svoju registraciju i povezivanje sa platformom, neko će ti od nas mahnuti, poželeti dobrodošlicu i pružiti svu pomoć i dodatne neophodne informacije.
                    </p>
                    <p>
                      Srećno sa kampanjama.
                    </p>
                  </div>
                  <!-- end col -->
                </div>
                <!-- end row -->
              </tab-content>
              <tab-content :title="form.name" v-for="(form, key)  in this.selectedForms" :key="key" :before-change="generateCallback(key)" >
                <h3 class="mb-4">{{ form.name }}</h3>
                <div class="row">
                  <div class="col-12">
                    <form :ref="form.name" autocomplete="on">
                      <div v-if="key === 'personalInfo'" class="form-group row mb-3">
                        <label class="col-12 col-md-5 col-form-label">Registered as</label>
                        <div class="col-12 col-md-7">
                          <multiselect  v-model="registeredAs"
                                        :options="['company', 'individual']"
                                        :allow-empty="false"
                                        deselectLabel=""
                                        class="text-capitalize"
                                        :multiple="false">
                            <template slot="option" slot-scope="props">
                              <div class="text-capitalize option__desc"><span class="option__title">{{ props.option }}</span></div>
                            </template>
                          </multiselect>
                        </div>
                      </div>
                      <div v-for="(field, fieldKey) in form.fields" :key="fieldKey" class="form-group row mb-3">
                        <label class="col-12 col-md-5 col-form-label" :for="fieldKey">{{ field.name }}:</label>
                        <div class="col-12 col-md-7">
                          <b-form-radio-group class="mb-2" v-if="field.type === 'radio'" v-model="field.value">
                            <b-form-radio :value="true" class="mb-1">Yes</b-form-radio>
                            <b-form-radio :value="false" class="mb-1">No</b-form-radio>
                          </b-form-radio-group>
                          <div v-else-if="field.type === 'date'">
                            <date-input v-model="field.value" @input="field.error = false" :error="field.error" :min-year="new Date().getFullYear() - 100" :max-year="new Date().getFullYear() - 13"></date-input>
                          </div>
                          <multiselect  v-else-if="field.type === 'select'"
                                        class="text-capitalize"
                                        :class="{ invalid: field.error }"
                                        v-model="field.value"
                                        :options="field.options"
                                        :allow-empty="false"
                                        deselectLabel=""
                                        @input="field.error = false"
                                        :multiple="false">
                            <template slot="option" slot-scope="props">
                              <div class="text-capitalize option__desc"><span class="option__title">{{ props.option }}</span></div>
                            </template>
                          </multiselect>
                          <phone-select
                              v-else-if="field.type === 'phone'"
                              v-model="field.value"
                              @input="field.error = false"
                              :field="field" ></phone-select>
                          <input
                              v-else
                              :id="fieldKey"
                              type="text"
                              :autocomplete="field.autocomplete"
                              class="form-control"
                              @input="field.error = false"
                              :class="{'is-invalid': field.error}"
                              :name="field.name.toLowerCase()"
                              :placeholder="field.placeholder"
                              v-model="field.value"
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                  <!-- end col -->
                </div>
                <!-- end row -->
              </tab-content>

              <tab-content title="Categories">
                <h3 class="mb-4">Categories</h3>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group row mb-3">
                      <label class="col-12 col-md-4 col-form-label">Choose categories:</label>
                      <div class="col-12 col-md-8">
                        <multiselect class="mb-4" :class="{ invalid: categories.error }" v-model="categories.selected" :options="categoriesOptions" @input="categories.error = false" :multiple="true"></multiselect>
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
                <!-- end row -->
              </tab-content>
              <template slot="footer" slot-scope="props">
                <div class="wizard-footer-left">
                  <button class="btn btn-primary px-4"  v-if="props.activeTabIndex > 0" @click="prevTab">Previous</button>
                </div>
                <div class="wizard-footer-right">
                  <button v-if="!props.isLastStep" @click="nextTab(props.activeTabIndex)" class="btn btn-primary px-4 wizard-footer-right">Next</button>

                  <button v-else @click="complete" class="btn btn-primary px-4 wizard-footer-right">  {{props.isLastStep ? 'Done' : 'Next'}}</button>
                </div>
              </template>
            </form-wizard>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

  </Layout>
</template>
